import { render } from "./BaseKeyValueList.vue?vue&type=template&id=77c09cb2"
import script from "./BaseKeyValueList.vue?vue&type=script&lang=js"
export * from "./BaseKeyValueList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__